import { useState } from 'react'
import { aktuellePhase, phaseDerChecklist, phaseIndex, checklistenAnzeigeName, checklistenFortschritt } from '@pilot-hub/ui'
import { Card } from '@pilot-hub/ui'
import { Check, ChevronDown, ChevronUp } from 'lucide-react'
import { PhasenAnzeige } from './PhasenAnzeige'

interface Inst { id: number; name: string; phase: string; modul: string; status: string; flug_id: number | null; items: { id: number; text: string; typ: string; pflicht: boolean; wert: string | null }[] }

/** Phase des Einsatzes und seine noch offenen Einsatz-Checklisten (einmal je Einsatz; vom Co-Pilot abgeschlossene entfallen) – nur lesend; abgehakt wird im Co-Pilot-Modus */
export function EinsatzChecklistenLesen({ einsatz, checklisten }: { einsatz?: { typ?: string | null; status?: string | null; phase?: string | null } | null; checklisten: Inst[] }) {
  const [offen, setOffen] = useState<number | null>(null)
  const phase = aktuellePhase(einsatz)
  const liste = checklisten.filter(c => c.modul === 'PILOT' && !c.flug_id && phaseDerChecklist(c.modul, c.phase) && !checklistenFortschritt(c).fertig)
    .sort((a, b) => phaseIndex(phaseDerChecklist(a.modul, a.phase), einsatz?.typ) - phaseIndex(phaseDerChecklist(b.modul, b.phase), einsatz?.typ))
  return (
    <div className="space-y-3" data-testid="einsatz-checklisten-lesen">
      <PhasenAnzeige einsatz={einsatz} />
      {liste.length > 0 && (
        <Card className="p-4 space-y-2">
          <h2 className="text-base font-semibold text-dark-text">Einsatz-Checklisten <span className="text-sm font-normal text-dark-text-muted">(werden vom Co-Pilot abgehakt)</span></h2>
          {liste.map(c => {
            const f = checklistenFortschritt(c)
            const istAktuell = !!phase && phaseDerChecklist(c.modul, c.phase) === phase
            return (
              <div key={c.id} className={`rounded-lg border p-3 ${istAktuell ? 'border-primary-400 bg-primary-600/10' : 'border-dark-border bg-dark-bg-tertiary/40'}`}>
                <button type="button" onClick={() => setOffen(o => (o === c.id ? null : c.id))} className="flex min-h-[44px] w-full items-center justify-between gap-2 text-left">
                  <span className="flex items-center gap-2 font-medium text-dark-text">
                    {f.fertig ? <Check className="h-4 w-4 text-green-400" /> : <span className="h-2 w-2 rounded-full bg-amber-400" />}
                    {checklistenAnzeigeName(c.phase, einsatz?.typ) ?? c.name}
                    {istAktuell && <span className="rounded-full bg-primary-600 px-2 py-0.5 text-xs text-white">aktuelle Phase</span>}
                  </span>
                  <span className="flex items-center gap-2 text-sm text-dark-text-muted">{f.erledigt}/{f.gesamt} Pflicht{offen === c.id ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}</span>
                </button>
                {offen === c.id && (
                  <ul className="mt-2 space-y-1 text-sm">
                    {c.items.map(i => (
                      <li key={i.id} className="flex gap-2 rounded bg-dark-bg-tertiary/50 p-2">
                        <span className={i.wert ? 'text-green-400' : 'text-dark-text-muted'}>{i.typ === 'CHECK' ? (i.wert === 'true' ? '☑' : '☐') : '•'}</span>
                        <span className="min-w-0 flex-1 [overflow-wrap:anywhere] text-dark-text">{i.text}{i.typ !== 'CHECK' && i.wert ? `: ${i.wert}` : ''}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )
          })}
        </Card>
      )}
    </div>
  )
}
